import React from 'react'
import styled, { keyframes } from 'styled-components'

const H1 = styled.h1`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`

const Placeholder = ({ children, ...props }) => {
  return (
    <H1 {...props}>
      {children}
    </H1>
  )
}

export default Placeholder
